import React, { useEffect, useState, useMemo } from 'react';
import { Space, Table, Tag, Button, Image, Card, Input, Flex, Select } from 'antd';
import { useNavigate, useSearchParams } from "react-router";
import { DeleteOutlined, EditOutlined, EyeOutlined } from '@ant-design/icons';
import ProductCategoryService from 'services/product_category';
import { useApp } from "contexts/app";
import _ from "lodash"
const { Search } = Input;
const service = new ProductCategoryService();


const ProductCategory = () => {
  let navigate = useNavigate();
  const [data, setData] = useState([]);
  const { showNotify, modal, showLoading, prompt } = useApp();
  const [filter, setFilter] = useState({})

  useEffect(() => {
    delaySearch(filter);


  }, [filter])

  const onSearch = async (data) => {
    var postData = { info: data?.info };
    var list = await service.list(postData);
    setData(list);
  }


  const delaySearch = useMemo(() => _.debounce(onSearch, 500, { leading: false }), []);


  const setFilterValue = (name, value) => {

    var newFilter = { ...filter };
    newFilter[name] = value;
    setFilter(newFilter)
  }

  const loadData = async () => {
    var list = await service.list();
    setData(list);
  }

  const createTag = () => {
    prompt({
      title: "Tạo tag", label: "Nhập tên",
      onOk: async (text) => {

        showLoading(true);
        await service.create({ name: text });

        await loadData();
        showLoading(false)
      }
    });
  }



  const editTag = (id) => {
    prompt({
      title: "Chỉnh sửa", label: "Nhập tên",
      onOk: async (text) => {

        showLoading(true);
        await service.update({ name: text, id: id });
        await loadData();
        showLoading(false)
      }
    });
  }

  const deleteTag = (id) => {
    modal.confirm({
      title: "Xoá?", content: "Bạn có chắc chắn muốn xoá", onOk: async () => {

        showLoading(true);
        await service.delete( id );
        await loadData();
        showLoading(false)


      }
    })
  }



  const columns = [
    {
      title: 'Sản phẩm',
      render: (_, record) => {
        return (
          <div>
            <Space>

              <div>
                {record.name}
              </div>
            </Space>
          </div>

        )
      }
    },


    {
      title: "",
      key: 'action',
      render: (_, record) => (
        <Space size="middle">
          <Button type='link' onClick={e => editTag(record.id)}><EditOutlined /></Button>
          <Button type='link' onClick={e => deleteTag(record.id)}><DeleteOutlined /></Button>
        </Space>
      ),
    },
  ];



  return (

    <Space direction="vertical" size={16} style={{ width: "100%" }}>
      <Card style={{ width: "100%" }}>

        <Space direction="vertical" size={8} style={{ width: "100%" }} >
          <Search
            placeholder="Tên hoặc mã"
            onChange={e => setFilterValue("info", e.target.value)}
            style={{
              width: "100%",
            }}
            value={filter.info}
          />

          <Flex justify='flex-end' style={{ width: "100%" }}>
            <Button type='primary' onClick={e => createTag()} >Thêm mới</Button>
          </Flex>
        </Space>

      </Card>
      <Card>
        <Table columns={columns} dataSource={data} />
      </Card>
    </Space>
  )
}
export default ProductCategory;